import React from "react";
import { Row, Col, Typography } from "antd";
import { InputCheckbox } from "../../atoms/FormElement";

export const CheckboxWrapper = ({ options = [], setValue, control, parentLable, idx }) => {
  const { Text } = Typography;
  return (
    <>
      <Row gutter={[8, 8]}>
        {options.map((item, index) => {
          const fieldName = `dynamicFields.${item?.name}`;
          return (
            <Col key={item.name + idx + index} style={{ marginBottom: "0.75rem" }}>
              <InputCheckbox
                fieldname={fieldName}
                label={item.label}
                control={control}
                iProps={{ className: "prm-checkbox dynamic-checkBox", disabled: item?.isDisabled }}
                setValue={setValue}
                valueGot={item?.default}
              />
            </Col>
          );
        })}
      </Row>
    </>
  );
};
